export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "tech_visit": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Visita técnica"])},
            "ref_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])},
            "registered_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de visita"])},
            "latitude": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Latitud"])},
            "longitude": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Longitud"])},
            "next_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de próxima visita"])},
            "crop_field_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campo"])},
            "producer_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor"])},
            "inspector_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspector"])},
            "tech_visit_form_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulario"])}
          }
        }
      },
      "en": {
        "model": {
          "tech_visit": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tech visit"])},
            "ref_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code"])},
            "registered_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registered at"])},
            "latitude": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Latitude"])},
            "longitude": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Longitude"])},
            "next_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next at"])},
            "crop_field_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crop field"])},
            "producer_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producer"])},
            "inspector_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspector"])},
            "tech_visit_form_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form"])}
          }
        }
      }
    }
  })
}